import { OverLayFields } from '../models/OverlayFields';
import { PositioningType } from '../models/PositioningType';

export const PCPPositioning: PositioningType[] = [
  {
    overlayField: OverLayFields.LastGoodScan,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.CurrentCommunicationStatus,
    position: { x: 119, y: 248 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ControllerType,
    position: { x: 119, y: 284 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RTUAddress,
    position: { x: 119, y: 324 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TimeInState,
    position: { x: 119, y: 364 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RodStrings,
    position: { x: 600, y: 618 },
    justification: 'right',
  },
  {
    overlayField: OverLayFields.MotorType,
    position: { x: 575, y: 204 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TubingPressure,
    position: { x: 575, y: 395 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.CasingPressure,
    position: { x: 575, y: 435 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpDepth,
    position: { x: 573, y: 540 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpEfficiency,
    position: { x: 573, y: 578 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpType,
    position: { x: 573, y: 618 },
    justification: 'left',
  },
];
